import { z } from 'zod';
import {
  StudentDocumentId,
  StudentId,
  FamilyId,
  ResourceId,
  UserId,
} from '../types/branded';
import { DocumentCategorySchema, DocumentStatusSchema } from '../types/enums';

export const StudentDocumentSchema = z.object({
  id: StudentDocumentId,
  studentId: StudentId,
  familyId: FamilyId,
  documentGroupId: z.string().nullable().optional(),
  resourceId: ResourceId.nullable().optional(),
  name: z.string().min(1),
  fileName: z.string().nullable().optional(),
  fileType: z.string().nullable().optional(),
  fileSizeBytes: z.number().int().nonnegative().nullable().optional(),
  storageKey: z.string().nullable().optional(),
  storageBucket: z.string().nullable().optional(),
  category: DocumentCategorySchema,
  status: DocumentStatusSchema.nullable().optional(),
  verified: z.boolean().default(false),
  verifiedBy: UserId.nullable().optional(),
  verifiedAt: z.string().nullable().optional(),
  uploadedBy: UserId.nullable().optional(),
  notes: z.string().nullable().optional(),
  uploadedAt: z.string(),
});
export type StudentDocument = z.infer<typeof StudentDocumentSchema>;
